import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8fb468"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]

import { ref, nextTick } from "vue" 


export default /*#__PURE__*/_defineComponent({
  __name: 'tagViewer',
  props: ["tag", "removable"],
  emits: ["deleteTag"],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const isTagClicked = ref(false)
const deleteTag = ref<HTMLElement | null>(null)

const handleTagClick = async () => {
    isTagClicked.value = true
    await nextTick()
    deleteTag.value?.focus()

}

const emitDeleteTag = () => {
    emits("deleteTag", props.tag)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _withModifiers(handleTagClick, ["stop"]),
    style: _normalizeStyle({ 'backgroundColor': __props.tag.color }),
    title: __props.tag.desc ? __props.tag.desc : '',
    class: "ac-tag-container relative"
  }, [
    _createTextVNode(_toDisplayString(__props.tag.name) + " ", 1),
    (__props.removable && isTagClicked.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _withModifiers(emitDeleteTag, ["stop"]),
          ref_key: "deleteTag",
          ref: deleteTag,
          tabindex: "0",
          onBlur: _cache[0] || (_cache[0] = ($event: any) => (isTagClicked.value = false)),
          class: "remove-tag"
        }, " Kaldır ", 544))
      : _createCommentVNode("", true)
  ], 12, _hoisted_1))
}
}

})